var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import BaseSlider from "../../slider/Slider";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n  cursor: pointer;\n"], ["\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n  cursor: pointer;\n"])));
export var Slider = styled(BaseSlider)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 21.2rem;\n  opacity: ", ";\n"], ["\n  height: 21.2rem;\n  opacity: ", ";\n"])), function (_a) {
  var isHidden = _a.isHidden;
  return isHidden ? 0.5 : 1;
});
export var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
var templateObject_1, templateObject_2, templateObject_3;